import { useMutation } from "@tanstack/react-query";
import { loginFromProps } from "../types/login";
import { axiosInstance } from "../util/axios";
import { notification } from "antd";
import { useTranslation } from "react-i18next";

export const useLogin = () => {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: (data: loginFromProps) =>
      axiosInstance.post(`/auth/login`, data),
    onSuccess: () => {
      document.location.href = "portal";
    },
    onError: () => {
      notification.error({
        message: t("toast.login-failed"),
        description: t("toast.please-check-your-credentials"),
      });
    },
  });
};
